import { formatCurrencyFn } from "../../Core/Functions/formatCurrencyFn";
import type { PhotographyPackageModel } from "../../Core/Models/PackageModels";
import { RouteConstants } from "../../Core/Constants/RouteConstants";
import { ButtonPiece } from "../../Shared/UI/ButtonPiece";

const accentClassNames = {
  red: "border-cmj-red/30 bg-cmj-red/10",
  gold: "border-cmj-gold/30 bg-cmj-gold/10",
  white: "border-white/20 bg-white/10",
};

export const PackageCardPiece = ({
  packageItem,
}: {
  packageItem: PhotographyPackageModel;
}) => (
  <article className={`panel-surface studio-package-card ${packageItem.featured ? "studio-package-featured" : ""} flex h-full flex-col gap-6 p-6 sm:p-8`}>
    <div className="flex items-start justify-between gap-4">
      <div>
        <span
          className={[
            "inline-flex rounded-md border px-3 py-1 text-xs font-black uppercase",
            accentClassNames[packageItem.accent],
          ].join(" ")}
        >
          {packageItem.featured ? "Featured package" : "Package"}
        </span>
        <h2 className="mt-4 font-display text-4xl uppercase text-white">
          {packageItem.name}
        </h2>
        <p className="mt-2 text-sm font-black uppercase text-cmj-gold">
          {packageItem.tagline}
        </p>
      </div>
      <div className="text-right">
        <p className="text-xs font-black uppercase text-cmj-mist">From</p>
        <p className="font-display text-5xl text-cmj-gold">
          {formatCurrencyFn(packageItem.startingPrice)}
        </p>
      </div>
    </div>
    <p className="text-base leading-7 text-cmj-mist">{packageItem.description}</p>
    <div className="grid gap-3 sm:grid-cols-2">
      <div className="rounded-md border border-white/10 bg-white/5 p-4">
        <p className="text-xs font-black uppercase text-cmj-gold">Session length</p>
        <p className="mt-2 text-2xl font-semibold text-white">
          {packageItem.duration}
        </p>
      </div>
      <div className="rounded-md border border-white/10 bg-white/5 p-4">
        <p className="text-xs font-black uppercase text-cmj-gold">Turnaround</p>
        <p className="mt-2 text-2xl font-semibold text-white">
          {packageItem.turnaround}
        </p>
      </div>
    </div>
    <ul className="grid gap-2">
      {packageItem.deliverables.map((deliverable) => (
        <li
          key={deliverable}
          className="rounded-md border border-white/10 bg-white/5 px-4 py-3 text-sm text-cmj-white"
        >
          {deliverable}
        </li>
      ))}
    </ul>
    <div className="mt-auto flex flex-wrap gap-3">
      <ButtonPiece
        appearance="secondary"
        to={`${RouteConstants.booking}?package=${packageItem.id}`}
      >
        Book This Package
      </ButtonPiece>
      <ButtonPiece appearance="ghost" to={RouteConstants.contact}>
        Ask a Question
      </ButtonPiece>
    </div>
  </article>
);

export const PackageComparisonPiece = ({
  packageItem,
}: {
  packageItem: PhotographyPackageModel;
}) => (
  <div className="rounded-md border border-white/10 bg-white/5 p-5">
    <div className="flex items-center justify-between gap-4">
      <h3 className="font-display text-3xl uppercase text-white">
        {packageItem.name}
      </h3>
      <span className="text-sm font-black uppercase text-cmj-gold">
        {packageItem.duration}
      </span>
    </div>
    <div className="mt-4 flex flex-wrap gap-2">
      {packageItem.idealFor.map((item) => (
        <span
          key={item}
          className="rounded-md border border-cmj-gold/30 px-3 py-1 text-xs font-black uppercase text-cmj-mist"
        >
          {item}
        </span>
      ))}
    </div>
  </div>
);
